var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"economic-volume"},[_vm._m(0),_c('div',{staticClass:"chart-con"},[_c('TabList',{staticClass:"po",attrs:{"list":_vm.tabList,"act":_vm.tabIndex},on:{"clickItem":(item, i) => {
          _vm.tabIndex = i;
        }}}),_c('v-chart',{ref:"bar-chart",staticClass:"bar-chart",attrs:{"id":"bar-chart","options":_vm.chartOption}})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title"},[_c('span',[_vm._v("广东省经济进出口额")])])
}]

export { render, staticRenderFns }